// @flow
import React from 'react';
import cx from 'classnames';

import './FakeBrandCard.scss';
import Brandpone from '../Brandpone/Brandpone';
import GrayBox from "../GrayBox";
import GrayBoxes from "../GrayBoxes";

// type GrayBoxProps = {
//   min: number,
//   max: number,
// };
//
// class GrayBox extends React.Component<GrayBoxProps> {
//   static defaultProps = {
//     min: 1,
//     max: 6,
//   };
//   size: number = 1;
//
//   constructor(props) {
//     super(props);
//     const { max, min } = this.props;
//     this.size = min + Math.random() * (max - min);
//   }
//
//   render() {
//     return <div className="gray-box keyframes blink" style={{ width: `${this.size}rem` }} />;
//   }
// }
//
// type GrayBoxesProps = {
//   count: number,
//   min?: number,
//   max?: number,
// };
//
// const GrayBoxes = ({ count, min, max }: GrayBoxesProps) => {
//   const array = Array.from(Array(count).keys());
//   return array.map(num => <GrayBox key={num} min={min} max={max} />);
// };

type Props = {
  oneColumn?: boolean,
};

const FakeBrandCard = ({ oneColumn }: Props) => (
  <Brandpone duration={100}>
    <div className={cx('BrandCard FakeBrandCard', { 'one-column': oneColumn })}>
      <div className="thumbnail-wrapper">
        <img src="https://images.cacheby.com/placeholder.png?s=600x316&t=crop&q=82&f=webp" alt="thumbnail" />
      </div>
      <div className="card-content">
        <div className="content-head">
          <h3 className="seller-name">
            <GrayBox min={4} max={6} />
          </h3>
          <div className="description">
            <GrayBoxes countMin={4} countMax={8} sizeMax={2} sizeMin={5} />
          </div>
        </div>
      </div>
    </div>
  </Brandpone>
);

FakeBrandCard.defaultProps = {
  oneColumn: false,
};

export default FakeBrandCard;



// WEBPACK FOOTER //
// ./src/components/common/FakeBrandCard/FakeBrandCard.js